<template>
  <NameComponent/>
  <HeaderComponent/>
  <AboutComponent/>
  <BodyComponent/>
  <BodyBody/>
  <QualificationComponent/>

  <ContactComponent/>
  <FooterComponent/>
</template>

<script>

import NameComponent from './components/NameComponent.vue'
import AboutComponent from '/src/components/AboutComponent.vue'
import HeaderComponent from '/src/components/HeaderComponent.vue'
import BodyComponent from '/src/components/BodyComponent.vue'
import FooterComponent from '/src/components/FooterComponent.vue'
import ContactComponent from '/src/components/ContactComponent.vue'
import QualificationComponent from '/src/components/QualificationComponent.vue'
import BodyBody from '/src/components/BodyBody.vue'


export default {
  name: 'App',
  components: {
    NameComponent,
    HeaderComponent,
    ContactComponent,
    QualificationComponent,
    BodyBody,
    BodyComponent,
    FooterComponent,
    AboutComponent
}
}
</script>

<style>

body{
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
}
</style>
